'use client';

import type { ReactNode } from 'react';
import Table from '@/ui/Table';
import type { TableProps } from '@/ui/Table';

type GroupTableViewProps<TData> = {
    tableBindings: TableProps<TData>;
    modals: ReactNode;
};

export const GroupTableView = <TData,>({ tableBindings, modals }: GroupTableViewProps<TData>) => (
    <>
        <Table {...tableBindings} />
        {modals}
    </>
);
